import GroupIcon from "@mui/icons-material/Group";
import { Box, Chip, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { colors, alphaVar } from "../../../../ui/colors";

export const JobCardWorkforce = ({ events }) => {
  if (!events?.length) return null;

  const currentEvent = events[0];
  const list = currentEvent.workforce || [];

  if (!list.length) return null;

  const formatDate = (date) => (date ? DateTime.fromISO(date).toFormat("hh:mm a, MMM d") : "");

  const calcDuration = (startAt, endAt) => {
    if (!startAt) return null;

    const start = DateTime.fromISO(startAt);
    const end = endAt ? DateTime.fromISO(endAt) : DateTime.now();

    const diff = end.diff(start, ["minutes"]).toObject();
    return diff.minutes || 0;
  };
  return (
    <Box sx={{ pl: 1 }}>
      <Box display="flex" alignItems="center" gap={1.5} mb={1}>
        <GroupIcon sx={{ color: colors.orange.base, fontSize: 20 }} />
        <Typography
          variant="caption"
          sx={{ color: colors.gray[400], fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em", fontSize: "0.6rem" }}
        >
          Workforce
        </Typography>
      </Box>

      {list.map((person) => {
        const wf = person.WorkforcesByJobEvents;

        const duration = wf?.startAt ? calcDuration(wf.startAt, wf.endAt) : null;

        return (
          <Box key={person.uid} sx={{ display: "flex", alignItems: "center", gap: 2, ml: 1, mt: 0.3, mb: 1.5 }}>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, color: colors.gray[800], fontSize: "0.74rem", lineHeight: 1.35 }}>
                {person.firstName} {person.lastName}
              </Typography>
              {wf && (
                <Chip
                  size="small"
                  label={wf.status}
                  sx={{
                    fontSize: "0.6rem",
                    bgcolor: alphaVar(colors.blue.base, 0.15),
                    color: colors.blue.base,
                    fontWeight: 600,

                    height: { xs: 0, sm: 22 },
                  }}
                />
              )}
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3, ml: 1, pl: 2 }}>
              {wf.startAt && (
                <Typography variant="caption" sx={{ color: colors.gray[600] }}>
                  Start: {formatDate(wf.startAt)}
                </Typography>
              )}

              {duration && (
                <Typography
                  variant="caption"
                  sx={{
                    color: colors.green,
                    fontWeight: 600,
                  }}
                >
                  Duration: {Number(duration).toFixed(1)}
                </Typography>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
